import { useEffect, useRef, useState } from "react";
import { JourneyScene } from "@/three/JourneyScene";

export const JourneyCanvas = ({
    onActChange,
    onUserNavigate,
    onExploreChange,
    onReady,
}) => {
    const mountRef = useRef(null);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        let scene = null;
        try {
            scene = new JourneyScene(mountRef.current, {
                onActChange,
                onUserNavigate,
                onExploreChange,
            });
            onReady?.(scene);
        } catch (err) {
            console.error("WebGL init failed:", err);
            setFailed(true);
        }
        return () => {
            if (scene) scene.dispose();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div
            data-testid="journey-canvas"
            className="fixed inset-0 z-0"
            aria-hidden="true"
        >
            {failed ? (
                <div className="journey-fallback h-full w-full" />
            ) : (
                <div ref={mountRef} className="h-full w-full" />
            )}
        </div>
    );
};

export default JourneyCanvas;
